/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useMemo, useContext } from "react";
import axios from "axios";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Popup from "reactjs-popup";
import SignaturePad from "react-signature-canvas";
import TSSelect from "components/Forms/TSSelect";
import DateRange from "@material-ui/icons/DateRange";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CardIcon from "components/Card/CardIcon.js";
import Icon from "@material-ui/core/Icon";
// core components
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
// import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import { Collapse, Modal, ModalBody } from "reactstrap";
// import avatar from "assets/img/faces/marc.jpg";
import { YearContext } from "components/CustomYear/YearContext";
var currentUser = "";
if(JSON.parse(localStorage.getItem('currentUser')) !== null){
  currentUser = JSON.parse(localStorage.getItem('currentUser'))
}

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontFamily: '"Sarabun", sans-serif',
    marginBottom: "3px",
    textDecoration: "none"
  }
};

const styles2 = {
  signatureCanvas: {
    border: "1px solid black",
    width: "100%",
    minHeight: "350px"
  }
};

const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);

export default function Year({onYearChange}) {
  const classes = useStyles();
  //const [optionYear, setOptionYear] = useState([]);
  const options = [
    { label: "2569", value: "2569" },
    { label: "2568", value: "2568" },
    { label: "2567", value: "2567" },
    { label: "2566", value: "2566" }
  ];
  const { selectedYear, setSelectedYear } = useContext(YearContext);

  const handleChange = (value) => {
    setSelectedYear(value);
  };
  
  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader color="rose" stats icon>
              <CardIcon color="rose">
                <Icon>
                  <DateRange />
                </Icon>
              </CardIcon>
              <p className={classes.cardCategory}>กรุณาเลือก</p>
              <h3 className={classes.cardTitle}>
                ปีงบประมาณ <small></small>
              </h3>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                <TSSelect
                  options={options}
                  onChange={handleChange}
                  default={{ label: selectedYear, value: selectedYear }}
                />
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  )
};
